<template>
  <RevButtonCard
    :aria-label="label"
    class="overflow-hidden"
    data-qa="marketingCard"
    :hoverable="true"
    :to="url"
  >
    <picture>
      <RevIllustrationSource
        :height="1280"
        media="(min-width: 768px)"
        :src="srcLarge"
        :width="1280"
      />

      <RevIllustration
        :alt="alt || ''"
        :height="768"
        :src="srcSmall"
        :width="768"
      />
    </picture>
  </RevButtonCard>
</template>

<script setup lang="ts">
import { RevButtonCard } from '@ds/components/ButtonCard'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'

defineProps<{
  alt?: string
  label?: string
  srcSmall: string
  srcLarge: string
  url?: string
}>()
</script>
